import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=6429038a"
import script from "./ProgramsList.vue?vue&type=script&lang=js"
export * from "./ProgramsList.vue?vue&type=script&lang=js"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=6429038a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports